var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 329.19 33.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ed1e79;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u05E4\\u05E2\\u05D9\\u05DC\\u05D5\\u05EA_\\u05E6\\u05D9\\u05D1\\u05D5\\u05E8\\u05D9\\u05EA",
    "data-name": "\\u05E4\\u05E2\\u05D9\\u05DC\\u05D5\\u05EA \\u05E6\\u05D9\\u05D1\\u05D5\\u05E8\\u05D9\\u05EA"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.29,12.36h-7.28v20.07H0v-8.13h4.79v-11.94H1.41V4.23h29.09v28.2h-9.21V12.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.05,4.23h9.21v15.51h-9.21V4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.93,12.36h-13.02V4.23h22.23v28.2h-9.21V12.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.93,4.23h9.21v28.2h-9.21V4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.36,32.43h-24.86v-8.13h11.61v-11.94h-11.61V4.23h20.82v20.07h4.04v8.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.91,4.23h9.21v15.51h-9.21V4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.15,24.3h11.14l-12.5-15.37,6.72-5.69,8.37,10.62,8.41-10.81,6.58,4.98-9.73,12.5,9.26,11.75v.14h-28.25v-8.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.53,12.36h-7.28v20.07h-14.01v-8.13h4.79v-11.94h-3.38V4.23h29.09v28.2h-9.21V12.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.52,4.23h9.21v28.2h-9.21V4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.39,0h9.21v4.23h15.79l-12.17,29.14-8.41-3.43,7.43-17.58h-11.84V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M255.77,4.23h9.21v15.51h-9.21V4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.17,4.23v28.2h-27.87v-8.13h4.89V4.23h9.21v20.07h4.56V4.23h9.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M313.91,3.29c8.84,0,15.27,6.39,15.27,15.04s-6.44,15.04-15.27,15.04c-3.43,0-7.75-1.22-10.95-4.75l6.34-5.78c1.22,1.32,3.24,2.07,4.79,2.07,3.43,0,5.97-2.68,5.97-6.58s-2.54-6.58-5.97-6.58c-2.26,0-4.09,1.22-5.08,3.1h4.79v6.91h-14.38c-2.82-8.6,4.7-18.47,14.47-18.47Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdpi);
export default __webpack_public_path__ + "static/media/פעילות ציבוריתmdpi.c08f84646cefafeb62fe1d5ca77316ef.svg";
export { ForwardRef as ReactComponent };